import { render, staticRenderFns } from "./MealIngredientListItem.vue?vue&type=template&id=f2bde0e2&scoped=true&"
import script from "./MealIngredientListItem.vue?vue&type=script&lang=js&"
export * from "./MealIngredientListItem.vue?vue&type=script&lang=js&"
import style0 from "./MealIngredientListItem.vue?vue&type=style&index=0&id=f2bde0e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bde0e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VDivider,VHover,VIcon,VListItem,VListItemAction,VListItemContent,VSnackbar})
